var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: { name: "q-drawer-fade" },
      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          staticClass: "q-drawer__wrapper",
          attrs: { tabindex: "-1" },
        },
        [
          _c(
            "div",
            {
              staticClass: "q-drawer__container",
              class: _vm.visible && "q-drawer__open",
              attrs: { role: "document", tabindex: "-1" },
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.handleWrapperClick.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                {
                  ref: "drawer",
                  staticClass: "q-drawer",
                  class: [_vm.direction, _vm.customClass],
                  style: _vm.isHorizontal
                    ? `width: ${_vm.size}`
                    : `height: ${_vm.size}`,
                  attrs: {
                    "aria-modal": "true",
                    "aria-labelledby": "q-drawer__title",
                    "aria-label": _vm.title,
                    role: "dialog",
                    tabindex: "-1",
                  },
                },
                [
                  _vm.withHeader
                    ? _c(
                        "header",
                        {
                          staticClass: "q-drawer__header",
                          attrs: { id: "q-drawer__title" },
                        },
                        [
                          _vm._t("title", function () {
                            return [
                              _c(
                                "span",
                                {
                                  attrs: {
                                    role: "heading",
                                    tabindex: "0",
                                    title: _vm.title,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.title))]
                              ),
                            ]
                          }),
                          _vm._v(" "),
                          _vm.showClose
                            ? _c(
                                "button",
                                {
                                  staticClass: "q-drawer__close-btn",
                                  attrs: {
                                    "aria-label": `close ${
                                      _vm.title || "drawer"
                                    }`,
                                    type: "button",
                                  },
                                  on: { click: _vm.closeDrawer },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "q-dialog__close q-icon q-icon-close",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rendered
                    ? _c(
                        "section",
                        { staticClass: "q-drawer__body" },
                        [_vm._t("default")],
                        2
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }